import {
  Box,
  Button,
  Divider,
  Grid,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import CommonAutocomplete from "../../components/CommonAutocomplete";
import useInputObject from "../../hooks/useInputObject";
import { getHyphenedDate } from "../../utils/utils";
import { isNullObject } from "../../utils/validation";
import FORM_MODE from "./state/FormState";
import TRANSACTION_STATE from "./state/TransactionState";

//ショットカット展開
const ROW_COLUMN_COUNT = 6;
function handleKeyPress(event, submitDeposit) {
  if (event.key === "Enter") {
    //Right Enter. TODO : Use Right Enter
    if (event.location === 3) {
      event.preventDefault();
      focusNavigation(event.target, event.shiftKey);
    }
    //Left Enter, Open Modal
    else if (event.location === 0) {
      event.preventDefault();
      //Toroku
      submitDeposit();
      moveToElement(0);
    }
  }
}

function handleKeyDown(event) {
  //Arrow Handle
  const keyCode = event.keyCode;
  //Arrow Key
  if (keyCode === 38) {
    const ariaExpanded =
      event.target.getAttribute("aria-expanded") === "true" ? true : false;
    if (!ariaExpanded) {
      event.preventDefault();
      focusNavigation(event.target, true);
    }
  } else if (keyCode === 40) {
    const ariaExpanded =
      event.target.getAttribute("aria-expanded") === "true" ? true : false;
    if (!ariaExpanded) {
      event.preventDefault();
      focusNavigation(event.target, false);
    }
  }
}

function focusNavigation(currentElement, isPrevious = false) {
  const focusing = currentElement.id;
  const step = isPrevious ? -1 : 1;
  const currentRow = parseInt(focusing.split("-")[1], 10);
  let nextRow = currentRow + step;
  if (nextRow >= ROW_COLUMN_COUNT) nextRow = 0;
  moveToElement(nextRow);
}

function moveToElement(row = 0) {
  setTimeout(() => {
    const id = `transaction-${row}`;
    const element = document.getElementById(id);
    if (element) {
      element.focus();
    } else {
      console.log("Cannot find next element");
      console.log(`transaction-${row}`);
    }
  }, 0);
}
const DIVISIONS = Object.entries({
  50: "現金",
  51: "小切手",
  52: "振込",
  54: "先付小",
  56: "便引",
  55: "通信費",
  57: "相費",
  53: "手形",
  58: "その他",
}).map(([key, value]) => ({
  key: key,
  value: value,
}));

const emptyTransaction = {
  transactionDate: getHyphenedDate(),
  partnerNo: "",
  amount: 0,
  subjectCd: 0,
  staffId: 0,
  division: DIVISIONS[0],
};

const TransactionForm = (props) => {
  const { mode, insert, commodityOwners, buyers, selectTransaction } = props;
  const [formMode, setFormMode] = useState(FORM_MODE.INSERT);
  const [buyer, setBuyer] = useState();
  const [commodityOwner, setCommodityOwner] = useState();
  const transaction = useInputObject(emptyTransaction);

  const columns = ["No", "パートナー", "摘要", "区分", "金額", "科目", "担当"];

  function handleSubmitForm() {
    console.log("submit transaction form : ", transaction.Value);
    props.insertTransaction(transaction.Value);
    resetForm();
  }

  useEffect(() => {
    moveToElement(0);
  }, []);

  useEffect(() => {
    // if (!buyer && !commodityOwner) return;
    if (mode.Value == TRANSACTION_STATE.RECEIPT) {
      transaction.updates({
        partnerNo: buyer?.buyerNo || "",
        partnerName: buyer?.buyerName || "",
      });
    }
    if (mode.Value == TRANSACTION_STATE.PAYMENT) {
      transaction.updates({
        partnerNo: commodityOwner?.commodityOwnerCd || "",
        partnerName: commodityOwner?.commodityOwnerName || "",
      });
    }
  }, [buyer, commodityOwner]);

  function resetForm() {
    transaction.setValue(emptyTransaction);
    setBuyer(null);
    setCommodityOwner(null);
    setFormMode(FORM_MODE.INSERT);
  }

  useEffect(() => {
    //IF select transaction is null then not update form
    if (isNullObject(selectTransaction.Value)) {
      setFormMode(FORM_MODE.INSERT);
      resetForm();
      return;
    }

    setFormMode(FORM_MODE.UPDATE);
    transaction.setValue(selectTransaction.Value);
    if (mode.Value == TRANSACTION_STATE.RECEIPT) {
      setBuyer(
        buyers.find(
          (buyer) => buyer.buyerNo === selectTransaction.Value?.buyerNo
        )
      );
    }
    if (mode.Value == TRANSACTION_STATE.PAYMENT) {
      setCommodityOwner(
        commodityOwners.find(
          (commodityOwner) =>
            commodityOwner.commodityOwnerCd ===
            selectTransaction.Value?.commodityOwnerCd
        )
      );
    }
    transaction.update(
      "division",
      DIVISIONS.find((d) => d.key == selectTransaction.Value?.divisionCd)
    );
  }, [selectTransaction.Value]);

  return (
    <Box
      onKeyDown={(e) => handleKeyDown(e)}
      onKeyPress={(e) => handleKeyPress(e, handleSubmitForm)}
      onFocus={(e) => e.target.select()}
    >
      <Typography variant="h6" textAlign="left" mb={3}>
        {mode.Value == TRANSACTION_STATE.RECEIPT ? "入金" : "出金"}エントリ
      </Typography>
      <Grid item xs="auto" display="flex" alignItems="center" sx={{ p: 0 }}>
        <Typography sx={{ width: 100 }}>
          {mode.Value == TRANSACTION_STATE.RECEIPT ? "入金" : "支払"}日付
        </Typography>
        <TextField
          onChange={(e) =>
            transaction.update("transactionDate", e.target.value)
          }
          value={transaction.Value.transactionDate}
          sx={{ width: 500 }}
          type="date"
          id="transaction-0"
          InputProps={{
            paddingInline: 0,
            inputProps: {
              min: "1000-01-01",
              max: "9999-12-31",
            },
            ...props.InputProps,
          }}
        />
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid item xs="auto" display="flex" alignItems="center">
        <Typography sx={{ width: 100 }}>
          {mode.Value == TRANSACTION_STATE.RECEIPT ? "入金元" : "支払先"}
        </Typography>
        {mode.Value == TRANSACTION_STATE.PAYMENT ? (
          <CommonAutocomplete
            // label="支払い先"
            value={commodityOwner || null}
            onSelect={(e, newValue) => {
              setCommodityOwner(newValue);
              focusNavigation(document.activeElement, false);
            }}
            data={commodityOwners}
            filterOptions={(options, { inputValue }) => {
              inputValue = inputValue.trim();
              return options.filter(
                (x) =>
                  x.commodityOwnerCd.toString().startsWith(inputValue) ||
                  x.commodityOwnerName.includes(inputValue)
              );
            }}
            optionLabel={(option) =>
              option
                ? option.commodityOwnerCd + " - " + option.commodityOwnerName
                : ""
            }
            width={500}
            id="transaction-1"
          />
        ) : (
          <CommonAutocomplete
            // label="入金元"
            value={buyer || null}
            onSelect={(e, newValue) => {
              setBuyer(newValue);
              focusNavigation(document.activeElement, false);
            }}
            name="buyerNo"
            data={buyers}
            filterOptions={(options, { inputValue }) => {
              inputValue = inputValue.trim();
              return options.filter((x) => {
                return (
                  x.buyerNo.toString().startsWith(inputValue) ||
                  x.buyerName.includes(inputValue)
                );
              });
            }}
            optionLabel={(option) =>
              option ? option.buyerNo + " - " + option.buyerName : ""
            }
            width={500}
            id="transaction-1"
          />
        )}
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid item xs="auto" display="flex" alignItems="center">
        <Typography sx={{ width: 100 }}>区分</Typography>
        <CommonAutocomplete
          value={transaction.Value.division}
          onSelect={(e, newValue) => {
            transaction.update("division", newValue);
            focusNavigation(document.activeElement, false);
          }}
          id={`transaction-2`}
          data={DIVISIONS}
          filterOptions={(options, { inputValue }) => {
            inputValue = inputValue.trim();
            return options.filter(
              (x) => x.key.includes(inputValue) || x.value.includes(inputValue)
            );
          }}
          optionLabel={(option) =>
            option ? option.key + " - " + option.value : ""
          }
          width={500}
        />
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid item xs="auto" display="flex" alignItems="center">
        <Typography sx={{ width: 100 }}>金額</Typography>
        <OutlinedInput
          value={parseInt(transaction.Value.amount) || ""}
          onChange={(e) => transaction.update("amount", e.target.value)}
          sx={{ width: 500 }}
          type="number"
          inputProps={{
            disableUnderline: true,
            style: {
              color: "black",
              backgroundColor: "white",
            },
          }}
          id="transaction-3"
        />
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid item xs="auto" display="flex" alignItems="center">
        <Typography sx={{ width: 100 }}>科目</Typography>
        <OutlinedInput
          value={parseInt(transaction.Value.subjectCd) || ""}
          onChange={(e) => transaction.update("subjectCd", e.target.value)}
          sx={{ width: 500 }}
          type="number"
          inputProps={{
            disableUnderline: true,
            style: {
              color: "black",
              backgroundColor: "white",
            },
          }}
          id="transaction-4"
        />
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid item xs="auto" display="flex" alignItems="center">
        <Typography sx={{ width: 100 }}>担当</Typography>
        <OutlinedInput
          value={parseInt(transaction.Value.staffId) || ""}
          onChange={(e) => transaction.update("staffId", e.target.value)}
          sx={{ width: 500 }}
          type="number"
          inputProps={{
            disableUnderline: true,
            style: {
              color: "black",
              backgroundColor: "white",
            },
          }}
          id="transaction-5"
        />
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Box display="flex" justifyContent="space-around">
        <Button
          variant="contained"
          color={formMode === FORM_MODE.INSERT ? "success" : "error"}
          mt={3}
          onClick={handleSubmitForm}
        >
          {formMode === FORM_MODE.INSERT ? "追加" : "更新"}
        </Button>
        <Button
          variant="contained"
          color="warning"
          mt={3}
          onClick={(e) => {
            if (formMode === FORM_MODE.INSERT) resetForm();
            else if (formMode === FORM_MODE.UPDATE) {
              selectTransaction.setValue({});
              resetForm();
            }
          }}
        >
          {formMode === FORM_MODE.INSERT ? "クリア" : "キャンセル"}
        </Button>
        <Button
          variant="contained"
          color="primary"
          mt={3}
          onClick={props.closeModal}
        >
          戻る
        </Button>
      </Box>
    </Box>
  );
};

export default TransactionForm;
